import { useEffect } from 'react';
import { handleDeepLinkParams, hasDeepLinkParams } from 'utils/deepLinkUtils';

/**
 * Global component that handles deep link parameters on app load
 * This component should be included in the main App component to ensure
 * deep link parameters are processed regardless of the route
 */
const GlobalDeepLinkHandler = () => {
  useEffect(() => {
    // Check if we have deep link parameters in the current URL
    if (hasDeepLinkParams()) {
      console.log('GlobalDeepLinkHandler: Found deep link parameters in URL');
      
      // Process the deep link parameters
      const deepLinkParams = handleDeepLinkParams();
      
      if (Object.keys(deepLinkParams).length > 0) {
        console.log('GlobalDeepLinkHandler: Processed deep link parameters:', deepLinkParams);
        
        // If we're not on the add_store route, we might need to redirect
        // But we'll let the authentication flow handle the redirect
        if (window.location.pathname !== '/add_store') {
          console.log('GlobalDeepLinkHandler: Deep link parameters processed, authentication flow will handle redirect');
        }
      }
    }
  }, []); // Run only once on mount

  // This component doesn't render anything
  return null;
};

export default GlobalDeepLinkHandler;
